// extracted by mini-css-extract-plugin
module.exports = {"uploadBtn":"XeTTV","uploadBtnContainer":"Cmqb4","uploadBtnLabel":"CHZG6"};